import { definePlatformSetting } from '@crest/platform-contracts/settings';
import { z } from 'zod';
import { relationshipsContactStatusSchema, relationshipsContactTypeSchema } from '../contracts/relationships-contact.contract.js';
const label = z.string().trim().min(1).max(300);
// New versioned copy key leaves the existing summary/note copy contract unchanged.
export const relationshipsContactEditCopySchema = z.strictObject({
    editAction: label, heading: label, firstName: label, lastName: label, title: label,
    type: label, status: label, profileNotes: label, phone: label, alternatePhone: label,
    emails: label, email: label, emailLabel: label, primary: label, addEmail: label, removeEmail: label,
    organization: label, searchOrganizations: label, noOrganization: label, organizationLoading: label,
    organizationError: label, noOrganizations: label, previous: label, next: label, retry: label,
    notifySms: label, notifyEmail: label, preferencesHint: label, privateHidden: label,
    save: label, saving: label, cancel: label, invalid: label, uncertain: label, verify: label,
    saved: label, unchanged: label,
    typeLabels: z.record(relationshipsContactTypeSchema, label),
    statusLabels: z.record(relationshipsContactStatusSchema, label),
});
export const relationshipsContactEditCopySetting = definePlatformSetting({
    definition: {
        key: 'relationships.copy.contact-edit', moduleId: 'relationships', title: 'Contact editing copy',
        helpText: 'Labels for editing contact details, email addresses and organization linkage.',
        configurationDomain: 'copy', valueType: 'object', schemaVersion: 1,
        codedFallback: {
            editAction: 'Edit contact', heading: 'Edit contact', firstName: 'First name', lastName: 'Last name',
            title: 'Job title', type: 'Type', status: 'Status', profileNotes: 'Profile notes',
            phone: 'Phone', alternatePhone: 'Alternate phone', emails: 'Email addresses', email: 'Email',
            emailLabel: 'Email label', primary: 'Primary', addEmail: 'Add email', removeEmail: 'Remove email',
            organization: 'Organization', searchOrganizations: 'Search organizations', noOrganization: 'No organization',
            organizationLoading: 'Loading organizations…', organizationError: 'Organizations could not be loaded.',
            noOrganizations: 'No matching organizations.', previous: 'Previous organizations', next: 'Next organizations',
            retry: 'Retry', notifySms: 'SMS notifications', notifyEmail: 'Email notifications',
            preferencesHint: 'Notification preferences do not grant permission for outreach or change recorded consent.',
            privateHidden: 'Private phone and email fields are hidden and will be left unchanged.',
            save: 'Save contact', saving: 'Saving and checking…', cancel: 'Cancel',
            invalid: 'Check the contact fields and email addresses before saving.',
            uncertain: 'The save could not be confirmed. Your draft is retained. Check saved values before another save.',
            verify: 'Check saved values', saved: 'Contact saved and checked.', unchanged: 'No changes to save.',
            typeLabels: { customer: 'Customer', adjuster: 'Adjuster', agent: 'Agent', property_manager: 'Property manager',
                vendor: 'Vendor', internal: 'Internal', other: 'Other' },
            statusLabels: { active: 'Active', difficult: 'Difficult', vip: 'VIP', inactive: 'Inactive' },
        },
        permittedScopes: ['platform', 'plan', 'tenant'], mergeStrategy: 'deep-merge',
        clientSafe: true, serverOnly: false, sensitive: false, tenantEditable: true,
        userOverridable: false, offlineEligible: true, safetyClass: 'ordinary',
    },
    valueSchema: relationshipsContactEditCopySchema,
});
//# sourceMappingURL=relationships-contact-edit-copy.js.map